export default __webpack_public_path__ + "media/images/new_year/mosaic_mobile-f361a8e826f43903ee4ae3bb4f41c075.jpg";